import { jsGlobal } from "@awayfl/swf-loader";
export function wrapJSGlobalFunction(fun) {
    return function (sec) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return fun.apply(jsGlobal, args);
    };
}
